import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { includes, isEmpty } from 'lodash';
import Promise from 'bluebird';
import { withRouter } from 'react-router-dom';
import queryString from 'query-string';
import { RuntimeContext } from '../../../../../common/RuntimeContext';

import VerbButton, { VERB_BUTTON_TYPE } from '../../../../shared/components/VerbButton';
import PageContent from '../../../../shared/components/PageContent';
import PageHeader from '../../../../shared/components/PageHeader';
import Page from '../../../../shared/components/Page';
import DropzoneFileUpload from '../../../../shared/components/formComponents/inputs/DropzoneFileUpload';
import TextInput from '../../../../shared/components/formComponents/inputs/TextInput';
import {
    filePost,
    updateFileMetadata,
    getFileMetadata
} from '../../../../shared/actions';
import { getFileSize } from '../../../../shared/utils/NumberUtils';
import { checkStringForBannedCharacters, buildQueryString } from '../../../../shared/utils/StringUtils';

class AddOrEditMediaLibraryFile extends Component {
    static propTypes = {
        match: PropTypes.object,
        history: PropTypes.object,
        currentProfileId: PropTypes.string,
        loggedInUser: PropTypes.object,
        isAccountOwner: PropTypes.bool
    };

    static contextType = RuntimeContext;

    constructor(props) {
        super(props);

        this.state = {
            submitting: false,
            fileName: '',
            currentFileMetadata: {}
        };
    }

    componentDidMount() {
        const { match } =
            this.props;
        const promises = [];

        if (match.params && match.params.id) {
            promises.push(
                getFileMetadata({ metadataId: match.params.id, pathsContext: this.context.pathsWeb }).then((fileMetadata) => {
                    if (!fileMetadata) {
                        return this.props.history.push('/medialibrary');
                    }
                    return this.setState({
                        currentFileMetadata: fileMetadata,
                        fileName: fileMetadata.fileName
                    });
                })
            );
        }

        return Promise.all(promises);
    }

    componentDidUpdate(prevProps, prevState) {
        const { currentFileMetadata, fileName } = this.state;
        const { isAccountOwner, loggedInUser } = this.props;
        if (fileName !== prevState.fileName) {
            this._validateFileName(fileName);
        }
        if (isEmpty(prevProps.loggedInUser) && !isEmpty(loggedInUser)) {
            if (
                !currentFileMetadata ||
                (isAccountOwner && currentFileMetadata.uploadedBy.companyId !== loggedInUser.companyId)
            ) {
                return this.props.history.push('/medialibrary');
            }
        }
        return null;
    }

    _validateFileName = (name) => {
        const { faultCount, faultyChars } =
            checkStringForBannedCharacters(name, ['>', '<', ' ', '@', '$', '!', '#']) || {};

        this.setState({
            faultCount,
            nameValidationMessage: !isEmpty(faultyChars)
                ? `Name must not contain ${Object.keys(faultyChars).join(', ')}`
                : ''
        });
    };

    _handleSubmit = () => {
        const { file, fileName, currentFileMetadata } = this.state;
        const {
            match: { path, params },
            currentProfileId
        } = this.props;
        let submitPromise;
        const isNew = includes(path, 'new');
        this.setState({ submitting: true });
        if (isNew && file) {
            submitPromise = filePost({
                file,
                fileName,
                bucket: 'media',
                isPublic: true,
                profileId: currentProfileId,
                licenses: [],
                pathsContext: this.context.pathsWeb
            });
        } else {
            submitPromise = updateFileMetadata({
                fileMetadataId: params.id,
                updateParams: {
                    fileName,
                    isPublic: true,
                    licenses: [],
                    revision: currentFileMetadata.revision,
                    uploadedBy: currentFileMetadata.uploadedBy
                },
                pathsContext: this.context.pathsWeb
            });
        }

        return submitPromise
            .then((fileMetadata) => {
                this.setState({
                    currentFileMetadata: fileMetadata,
                    submitting: false,
                    fileName: fileMetadata.fileName,
                    successMessage: 'Success!'
                });
                return fileMetadata;
            })
            .catch(() => {
                this.setState({ errorMessage: 'Something went wrong..', submitting: false });
            });
    };

    _handleCancel = () => {
        this.props.history.push('/medialibrary');
    };

    _onFileUpload = (file) =>
        new Promise(() => {
            this.setState(() => ({
                file,
                fileName: file.name
            }));
        });



    render() {
        const {
            match: { path }
        } = this.props;
        const {
            submitting,
            fileName,
            successMessage,
            errorMessage,
            file,
            faultCount
        } = this.state;

        const isNew = includes(path, 'new');
        const parsedQueryString = queryString.parse(window.location.search);
        const title = isNew ? 'Add New File' : 'Edit File Details';
        const accept = 'image/*,application/pdf,video/mp4,audio/*'; // only accepts images, pdf, mp4
        return (
            <Page className={'add-or-edit-media-file'}>
                <PageHeader title={title} hideBackButton={true} />
                <PageContent className={'container'}>
                    {isNew && !file && (
                        <DropzoneFileUpload
                            accept={accept}
                            className={'row'}
                            dropzoneClass={'col-sm-12'}
                            onUpload={this._onFileUpload}
                        />
                    )}
                    {!!file && (
                        <div className={'row no-padding uploaded-file'}>
                            <div className={'col-6'}>{file.name}</div>
                            <div className={'col-6'}>{getFileSize(file.size)}</div>
                        </div>
                    )}
                    <br />
                    <br />
                    <div className={'row form-group'}>
                        <div className={'form-label-container'}>
                            <label className={'form-label'}>File Name</label>
                        </div>
                        <div className={'col-12 no-padding'}>
                            <TextInput
                                placeholder={'Enter file name'}
                                value={fileName}
                                onChange={(e) => {
                                    this.setState({
                                        fileName: e.target.value
                                    });
                                }}
                            />
                            <span style={{ color: 'red' }}>{this.state.nameValidationMessage}</span>
                        </div>
                    </div>
                    <br />
                    <div className={'row formButtons no-padding'}>
                        <VerbButton
                            fontAwesomeIcon={'fa-save'}
                            textId={'BUTTON_SAVE'}
                            defaultMessage={'SAVE'}
                            onClick={() =>
                                this._handleSubmit().then((fileMetadata) => {
                                    let url = `/editmedialibraryfile/${fileMetadata._id}`;
                                    if (!isEmpty(parsedQueryString)) {
                                        url = buildQueryString(
                                            parsedQueryString,
                                            `/editmedialibraryfile/${fileMetadata._id}`
                                        );
                                    }
                                    this.props.history.push(url);
                                })
                            }
                            disabled={(!file && isNew) || submitting || !fileName || faultCount}
                        />
                        <VerbButton
                            fontAwesomeIcon={'fa-save'}
                            textId={'BUTTON_SAVE_AND_EXIT'}
                            defaultMessage={'SAVE & EXIT'}
                            onClick={() =>
                                this._handleSubmit().then(() => {
                                    // if came from teams page, redirect to teams page
                                    if (parsedQueryString.teamId && parsedQueryString.companyId) {
                                        this.props.history.push(
                                            `/editcompany/${parsedQueryString.companyId}/teams/${parsedQueryString.teamId}`
                                        );
                                    } else {
                                        this.props.history.push('/medialibrary');
                                    }
                                })
                            }
                            disabled={(!file && isNew) || submitting || !fileName || faultCount}
                        />
                        <VerbButton
                            buttonType={VERB_BUTTON_TYPE.SECONDARY_DEFAULT}
                            fontAwesomeIcon={'fa-ban'}
                            textId={'BUTTON_CANCEL'}
                            defaultMessage={'CANCEL'}
                            onClick={this._handleCancel}
                            disabled={submitting}
                        />
                    </div>
                    <div className={'row no-padding'}>
                        <div className={'success-message'}>{successMessage}</div>
                        <div className={'error-message'}>{errorMessage}</div>
                    </div>
                </PageContent>
            </Page>
        );
    }
}

const mapStateToProps = (state) => {
    const {
        companies,
        auth: { loggedInUserId, loggedInUser }
    } = state;
    return {
        currentProfileId: loggedInUserId,
        loggedInUser,
        isAccountOwner: companies.byId[loggedInUser?.companyId]?.isAccountOwner || false
    };
};

export const AddOrEditMediaLibraryFileComponent = AddOrEditMediaLibraryFile;
export default withRouter(connect(mapStateToProps)(AddOrEditMediaLibraryFile));
